"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.payload = exports.initialValuesConfig = exports.idPrefix = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

var calcName = exports.calcName = 'financialplanningcheckuptool';
var idPrefix = exports.idPrefix = 'fpct_';

// Page validation goes below!

var validationPage1 = yup.object({
  isPlanningRetirementGoal: yup.boolean(),
  isTransitioningWealthGoal: yup.boolean(),
  isSavingForMajorPurchaseGoal: yup.boolean(),
  isBuildWealthGoal: yup.boolean(),
  isSavingForEducationExpensesGoal: yup.boolean(),
  isFamilyFinanciallySecureGoal: yup.boolean()
}).test('At least one goal is selected', null, value => {
  if (value.isPlanningRetirementGoal || value.isTransitioningWealthGoal || value.isSavingForMajorPurchaseGoal || value.isBuildWealthGoal || value.isBuildWealthGoal || value.isSavingForEducationExpensesGoal || value.isFamilyFinanciallySecureGoal) {
    return true; // Return true is at least one goal is selected
  }
  return new yup.ValidationError('Please check at least one checkbox', null, 'At least one goal is selected');
});
var validationPage2 = yup.object().shape({});
var validationPage3 = yup.object().shape({});
var validationPage4 = yup.object().shape({});
var validationConfig = exports.validationConfig = [validationPage1, validationPage2, validationPage3, validationPage4];

// Initial values go here!

var initialValuesConfig = exports.initialValuesConfig = {
  isPlanningRetirementGoal: false,
  isTransitioningWealthGoal: false,
  isSavingForMajorPurchaseGoal: false,
  isBuildWealthGoal: false,
  isSavingForEducationExpensesGoal: false,
  isFamilyFinanciallySecureGoal: false
};

// export const initialTouchedConfig = {}

var payload = exports.payload = {};
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: '',
    CONTENT_API_CALC_PDF: '',
    Icon: 'icon-document-check-black',
    Label: 'Financial plan check-up',
    SecondaryStyle: true,
    HasBorder: true,
    Steps: [{
      Title: '',
      SecondaryDescription: 'Nula vitae ornare neque. Lorem ipsum stuff',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Page 2 Title!',
      SecondaryDescription: 'Step 2 description goes here',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: '',
        Side: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: '',
      Description: '',
      SecondaryDescription: 'Step 3 description goes here - Lorem ipsum',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      RightHandButton: {
        Label: 'View disclosures',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Page 4 Title!',
      Description: '',
      SecondaryDescription: 'Step 4 description goes here',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Download as a PDF',
        Icon: 'icon-download',
        Variant: 'primary',
        Side: 'R',
        HideNext: false
      },
      RightHandButton: {
        Label: '',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }]
  }
};